import { trackEvent } from '@/lib/analytics';

type LandingEvent =
  | { action: 'hero_search'; query: string }
  | { action: 'category_click'; venueType: string }
  | { action: 'venue_card_click'; venueType: string }
  | { action: 'cta_click'; variant: 'vendor' | 'customer' }
  | { action: 'mobile_sticky_click' };

function getLandingLabel(event: LandingEvent): string {
  switch (event.action) {
    case 'hero_search':
      return event.query;
    case 'category_click':
      return event.venueType;
    case 'venue_card_click':
      return event.venueType;
    case 'cta_click':
      return event.variant;
    case 'mobile_sticky_click':
      return '';
  }
}

export function useLandingAnalytics() {
  const track = (event: LandingEvent) => {
    try {
      trackEvent(event.action, 'landing', getLandingLabel(event));
    } catch {
      // Analytics failures must never crash the page
    }
  };

  return { track };
}
